
import hljs from 'highlight.js';
import 'highlight.js/styles/github-dark.css';

hljs.highlightAll();